import ActivityCard from '../../components/components/activity-card/activity-card';

export const getActivityOptions = (activity, gameOptions) => {
  const defaultDifficulty = gameOptions.difficulties && gameOptions.difficulties[0];
  const defaultLevel = gameOptions.levels && gameOptions.levels[0];

  const skill = gameOptions.skills.find((skill) => parseInt(activity.skill, 10) === skill.id);
  const position = gameOptions.positions.find((position) => parseInt(activity.position, 10) === position.id);
  const difficulty =
    gameOptions.difficulties.find((difficulty) => parseInt(activity.difficulty, 10) === difficulty.id) ||
    defaultDifficulty;
  const level = gameOptions.levels.find((level) => parseInt(activity.level, 10) === level.id) || defaultLevel;
  const game = gameOptions.games.find((game) => parseInt(activity.game, 10) === game.id);

  return { skill, position, difficulty, level, game };
};

export const getGameSettings = (gameOptions, skill, position, level, game) => {
  return (
    gameOptions &&
    gameOptions.settings &&
    skill &&
    position &&
    level &&
    game &&
    gameOptions.settings.filter((setting) => {
      if (
        setting.skill !== skill.id ||
        setting.position !== position.id ||
        setting.level !== level.id ||
        setting.game !== game.id
      ) {
        return null;
      }
      return setting;
    })
  );
};

export function buildActivityCardWithData(activityData) {
  const game = activityData.game;
  const position = activityData.position;
  const skill = activityData.skill;
  const isReadOnly = true;
  const gameLevels = [1];
  const settings = {};
  const level = activityData.level;
  const isActive = true;
  const difficulty = activityData.difficulty;

  return (
    <ActivityCard
      activity={activityData}
      game={game}
      skill={skill}
      position={position}
      isReadOnly={isReadOnly}
      gameLevels={gameLevels}
      settings={settings}
      level={level}
      isActive={isActive}
      difficulty={difficulty}
    />
  );
}

export const buildActivityCard = (
  activity,
  gameOptions,
  isReadOnly,
  index,
  onClickRemove,
  onClickSettings,
  onChangeLevel,
  isActive,
  hideResults
) => {
  const activityOptions = getActivityOptions(activity, gameOptions);
  const skill = activityOptions.skill;
  const position = activityOptions.position;
  const difficulty = activityOptions.difficulty;
  const level = activityOptions.level;
  const game = activityOptions.game;

  const settings = getGameSettings(gameOptions, skill, position, level, game);

  const gameLevels =
    game &&
    game.levels.map((level) => {
      return gameOptions.levels.find((_level) => _level.id === level);
    });

  return (
    position &&
    skill &&
    difficulty &&
    level &&
    game && (
      <ActivityCard
        activity={activity}
        result={!hideResults && activity._result}
        game={game}
        skill={skill}
        position={position}
        difficulty={difficulty}
        level={level}
        settings={settings}
        gameLevels={gameLevels}
        isReadOnly={isReadOnly}
        onClickRemove={onClickRemove}
        onClickSettings={onClickSettings}
        onChangeLevel={onChangeLevel}
        isActive={isActive}
      />
    )
  );
};
